import { useHistory, generatePath } from 'react-router-dom';
import { SHOWCASE_PATH, CONNECTION_KNOVIO_PATH } from '../config/routes/paths';
import { PrivateMeetingDetailsResponseType } from '../lib/api';
import { JoinMethod } from '../lib/join-method/join-method';
import { usePathPrefix } from './use-path-prefix';
import { normalizeRoutePath } from '../lib/helpers/urlHelper';

export type ConnectionPrivateDetailsType = (
  PrivateMeetingDetailsResponseType
  & {
      joinMethodId: string,
      joinUrl?: string
  }
) | void;

/*
* Connection method precedence:
* 1 - Attendee level connection
* 1.1 - embedCodeId or showcasePagePath
* 1.2 - connectionLink
* 2 - Link set for an Attendee
*/

export const openWindow = (url?: string): void => {
  window.open(url ?? '', '_blank');
};

export default function useConnectToPrivateMeetingMethod(details: ConnectionPrivateDetailsType, joinMethod: JoinMethod | null): () => void {
  const history = useHistory();
  const pathPrefix = usePathPrefix();

  return () => {
    if (!details) return;

    const { meetingId, attendeeLink, joinUrl } = details;

    if (joinUrl) {
      return openWindow(joinUrl);
    }

    if (joinMethod) {
      if (joinMethod.isKnovioConnectionType()) {
        const normalizedRoutePath = normalizeRoutePath(CONNECTION_KNOVIO_PATH, pathPrefix);
        const params = {
          meetingId,
          joinMethodId: joinMethod.joinMethodId
        };
        const path = generatePath(normalizedRoutePath, params);

        return openWindow(path);
      }

      if (joinMethod.isShowcaseConnectionType()) return history.push(normalizeRoutePath(SHOWCASE_PATH, pathPrefix), { showcasePagePath: joinMethod.showcasePagePath });

      return openWindow(joinMethod.connectionLink);
    }

    return openWindow(attendeeLink);
  };
}
